interface PriceRange {
  minimum: number;
  maximum: number;
  /** The top of the slider, which reads open-ended ("$500+"). */
  sliderMaximum: number;
}

/**
 * A price filter's rule: the top of the slider is open-ended, so a filter parked
 * there never hides a pricier listing. A value typed past the top is a real limit.
 */
export const isWithinPriceRange = (
  priceMajorUnits: number,
  { minimum, maximum, sliderMaximum }: PriceRange,
): boolean =>
  priceMajorUnits >= minimum && (maximum === sliderMaximum || priceMajorUnits <= maximum);
